export const firebaseConfig = {
  apiKey: "AIzaSyBOQyBy_xppRpiWIQCiav0lXDZK_s_c2qI",
  authDomain: "speech2subs.firebaseapp.com",
  projectId: "speech2subs",
  storageBucket: "speech2subs.appspot.com",
  messagingSenderId: "778582987879",
  appId: "1:778582987879:web:4e9e169840cb2cd1d930c2",
  databaseURL: "https://speech2subs-default-rtdb.firebaseio.com",
  measurementId: "G-KCJG2L01VJ"
};